export const getSizeColorAdapter = (data) =>{

    let newData
    if(data?.length > 0){

        const arrayColor = []
        let colorActual = null
        data?.map(TC_Color => {
            const TC_Size = []
            data?.map( sizeArray => {
                if(sizeArray?.color === TC_Color?.color){
                    if(sizeArray?.stock >= 1){
                        const sizes = {
                            fulfillment: sizeArray?.fulfillment_id,
                            size: sizeArray?.size,
                            stock: sizeArray?.stock,
                            variant: sizeArray?.id,
                            id: sizeArray?.id,
                            sku: sizeArray?.sku
                        }
                        TC_Size.push( sizes )    
                    }
                }
                return false
            })
            const variation = {
                color: TC_Color.color,
                sizes: TC_Size
            }

            if(colorActual !== TC_Color.color){
                arrayColor.push(variation)
                colorActual = TC_Color.color
            }else{
                // console.log('colorB: ', colorActual === TC_Color.color)
            }

            return false
        })
        newData = arrayColor
    }else{
        newData = []
    }

    // console.log('data: ', data)
    // console.log('newData: ', newData)

    return newData
}